module.exports = __webpack_public_path__ + "resources/img/img_hi_psm_en.23021acab61a3ff3967433571dd286e0.png";